export default {"src":"/_next/static/media/success.mono.23989bd5.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};